'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:localcoin":true});}catch(e){}}();
import { useCallback, useSyncExternalStore } from 'react';

const DESKTOP_QUERY = '(min-width: 1024px)';
const WIDE_DESKTOP_QUERY = '(min-width: 1280px)';
const MOBILE_QUERY = '(max-width: 767px)';

// One MediaQueryList per query string. Creating a fresh one per subscriber would
// give each its own listener set, and matchMedia returns a new object every call.
const mediaQueryLists = new Map<string, MediaQueryList>();

const getMediaQueryList = (query: string): MediaQueryList => {
  const cached = mediaQueryLists.get(query);

  if (cached) {
    return cached;
  }

  const mediaQueryList = window.matchMedia(query);

  mediaQueryLists.set(query, mediaQueryList);

  return mediaQueryList;
};

const subscribeToQuery = (query: string, onStoreChange: () => void): (() => void) => {
  const mediaQueryList = getMediaQueryList(query);

  mediaQueryList.addEventListener('change', onStoreChange);

  return (): void => {
    mediaQueryList.removeEventListener('change', onStoreChange);
  };
};

// No snapshot cache: a boolean compares by value, so useSyncExternalStore's
// identity check is satisfied without memoising anything.
const getSnapshot = (query: string): boolean => getMediaQueryList(query).matches;

// The server has no viewport. Every consumer therefore renders its mobile branch
// first and settles on the real breakpoint after hydration - which is the point:
// reading the live breakpoint during the first render is what made every page
// mismatch [PAG-671].
const getServerSnapshot = (): boolean => false;

export const useMediaQuery = (query: string): boolean => {
  const subscribe = useCallback(
    (onStoreChange: () => void) => subscribeToQuery(query, onStoreChange),
    [query],
  );

  return useSyncExternalStore(subscribe, () => getSnapshot(query), getServerSnapshot);
};

export const useIsDesktop = (): boolean => useMediaQuery(DESKTOP_QUERY);

export const useIsWideDesktop = (): boolean => useMediaQuery(WIDE_DESKTOP_QUERY);

export const useIsMobile = (): boolean => useMediaQuery(MOBILE_QUERY);
